import { Component, ElementRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ChatService } from '../chat.service';
import { ChatEmotePipe } from '@shared/pipes/chat-emote.pipe';
import { NamePipe } from '@shared/pipes/name.pipe';
import { SessionService } from '@shared/session.service';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-chat-message-tooltip',
  templateUrl: './chat-message-tooltip.component.html',
  styleUrl: './chat-message-tooltip.component.scss',
  imports: [ChatEmotePipe, NamePipe],
})
export class ChatMessageTooltipComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  message: string;
  userLevel: number;
  @ViewChild('chatMessageTooltip', { read: ElementRef }) chatMessageTooltip: ElementRef<HTMLElement>;

  constructor(public session: SessionService, private chatService: ChatService, private uiService: UIService) {}

  ngOnInit() {
    this.subscription = this.chatService.onUserHover.subscribe((item) => {
      if (item.type === 'open') {
        this.message = item.text;
        this.userLevel = item.userLevel;

        if (this.uiService.uiState().chat === 'trimmed') {
          this.chatMessageTooltip.nativeElement.style.display = 'flex';

          const chatItemRect = item.element?.getBoundingClientRect();

          this.chatMessageTooltip.nativeElement.style.left = `${window.innerWidth - 80 - 140}px`;
          this.chatMessageTooltip.nativeElement.style.top = `${chatItemRect.top - chatItemRect.height / 2}px`;
        }
      }

      if (item.type === 'close') {
        this.chatMessageTooltip.nativeElement.style.display = 'none';
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
